import OncoreFlexMenuRow from './OncoreFlexMenuRow';

const OncoreFlexMenuFill = () => (
  <OncoreFlexMenuRow height="100%" />
);

export default OncoreFlexMenuFill;
